<template>
	<h3 class="reg heavy">
		<template v-for="(part, i) in formattedTitle">
			<component :key="i" v-if="part.component" :is="part.component" v-bind="part.props" />
			<span :key="i" v-html="getCleanHtml(part.text)" v-else />
		</template>
		<SIcon v-if="showVideoIcon && hasVideo" name="play-video" class="ml-1" />
	</h3>
</template>
<script>
import { sanitizeHtml } from '@/utils/helpers';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { userFavoritePlyServicesIds } from '@/store/modules/auth/getters.js';
import InspirationCenterService from '@/components/InspirationCenter/inspiration-center-service.js';
export default {
	name: 'IdeaFormattedTitle',
	props: { idea: { type: Object }, showVideoIcon: { type: Boolean } },
	computed: {
		...mapGettersShorthand({ userFavoritePlyServicesIds }),
		formattedTitle() {
			return InspirationCenterService.formatContentWithServiceDetails(this.idea.title, this.idea.params, this.userFavoritePlyServicesIds);
		},
		hasVideo() {
			return !!this.idea.video_url;
		},
	},
	methods: {
		getCleanHtml(dirtyContent) {
			return sanitizeHtml(String(dirtyContent));
		},
	},
};
</script>
